import styles from './uploadCreditReceiptForm.module.css'
import { Form, FormField, ModalId, useUIActions, FieldType, FileField, FileType, Validatable, Spinner } from "../../../../../features/ui"
import { useState } from "react"
import { toList } from "../../../../../utils/listUtils"
import { useActions } from "./actions"
import { useDataTypesHooks } from '../../../../../features/data-types'
import { CreditPayment } from '../../../state/types'
import { usePaymentTypeLoaders } from '../../../loaders/paymentTypeLoaders'
import { saleOperationHelpers } from '../../../../sales'
import { operationHelpers } from '../../../../operations'

type Props = {
    creditPayment?: CreditPayment
}

export const UploadCreditReceiptForm = (props: Props) => {
    const { creditPayment } = props
    
    const [receiptFile, setReceiptFile] = useState<File>()
    const [receiptValidation, setReceiptValidation] = useState<string>()
    
    const { describeCode } = operationHelpers
    const { paymentReceiptFileName } = saleOperationHelpers
    const { formatPrice } = useDataTypesHooks()
    
    const paymentTypeLoaders = usePaymentTypeLoaders()

    const { submitReceipt } = useActions()
    const { closeModal } = useUIActions()

    if (!creditPayment) return <Spinner />

    const onChangeFile = (value?: File) => {
        setReceiptValidation(undefined)
        setReceiptFile(value)
    }

    const fields: FormField[] = [
        {
            name: 'creditPayment',
            type: FieldType.TEXT,
            label: 'Cobro',
            render: () => <>{describeCode(creditPayment)}</>
        },
        {
            name: 'paymentItem',
            type: FieldType.TEXT,
            label: 'Medio de Pago',
            render: () => {
                const { findPaymentType } = paymentTypeLoaders()
                const paymentType = findPaymentType(creditPayment.paymentTypeId)!
                return <>{paymentType.name} ({formatPrice(creditPayment.amount)})</>
            }
        },
        {
            name: 'receiptFile',
            type: FieldType.FILE,
            label: 'Comprobante',
            hint: 'Formato: PDF, JPG, PNG',
            render: () => (
                <Validatable validations={toList(receiptValidation)} left className={styles.receiptValidation}>
                    <FileField
                        id="receiptUrl"
                        fileName={paymentReceiptFileName()}
                        fileTypes={[FileType.PDF, FileType.JPEG, FileType.PNG]}
                        onChange={onChangeFile}
                    />
                </Validatable>
            )
        }
    ]
    
    const validate = (): boolean => {
        if (!receiptFile) {
            setReceiptValidation('Debe subir el comprobante')
            return false
        }
    
        return true
    }

    const onSubmit = () => {
        if (validate()) {
            submitReceipt(creditPayment.id, receiptFile!)
        }
    }

    const handleCancel = () => closeModal(ModalId.UPLOAD_CREDIT_RECEIPT)

    return (
        <Form
            formId="upload-credit-receipt-form"
            fields={fields}
            createMode={false}
            updateLabel="Confirmar"
            onSubmit={onSubmit}
            onCancel={handleCancel}
        />
    )
}
